import CloseIcon from "@mui/icons-material/Close";
import { IconButton, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { Stack, SxProps } from "@mui/system";
import {
  API_ENVS,
  ApiEnvUrl,
  getActiveApiUrl,
  setActiveApiUrl,
} from "constants/API_ENV";
import { useState } from "react";

export default function DevBar({ sx = {} }: { sx?: SxProps }) {
  const [isClosed, setIsClosed] = useState(false);
  const isDeployedEnvironment = window.location.protocol === "https:";

  const apiUrl = getActiveApiUrl();
  const matchedEnv = API_ENVS.find((env) => env.url === apiUrl);
  const isLocalApi = matchedEnv?.label === "local";
  const backgroundColor = matchedEnv?.backgroundColor ?? "#424242";

  if (isDeployedEnvironment || (isClosed && isLocalApi)) return null;

  const handleEnvChange = (event: SelectChangeEvent) => {
    const nextUrl = event.target.value as ApiEnvUrl;
    if (nextUrl === apiUrl) return;
    setActiveApiUrl(nextUrl);
    window.location.reload();
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        backgroundColor,
        color: "#fff",
        height: 28,
        borderRadius: 1,
        pl: 1,
        pr: 0.25,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.35)",
        zIndex: 9999,
        ...sx,
      }}
    >
      <Select
        value={matchedEnv?.url ?? ""}
        displayEmpty
        onChange={handleEnvChange}
        variant="standard"
        disableUnderline
        renderValue={(value) => {
          const env = API_ENVS.find((option) => option.url === value);
          return env ? `DB: ${env.label}` : `DB: ${apiUrl}`;
        }}
        MenuProps={{
          anchorOrigin: { vertical: "top", horizontal: "left" },
          transformOrigin: { vertical: "bottom", horizontal: "left" },
          slotProps: {
            paper: {
              sx: { minWidth: 120 },
            },
          },
        }}
        sx={{
          color: "#fff !important",
          fontSize: "0.8125rem",
          fontWeight: 700,
          letterSpacing: "0.02em",
          width: "auto",
          minWidth: "6.75rem",
          height: "auto",
          p: 0,
          border: "none",
          borderRadius: 0,
          backgroundColor: "transparent !important",
          backgroundClip: "unset",
          placeItems: "unset",
          "& .MuiSelect-icon": { color: "#fff", right: 0 },
          "& .MuiSelect-select": {
            py: 0.5,
            pr: "1.5rem !important",
            pl: 0,
            width: "auto !important",
            backgroundColor: "transparent !important",
            color: "#fff !important",
          },
          "&:before, &:after": { display: "none" },
        }}
      >
        {API_ENVS.map((env) => (
          <MenuItem key={env.url} value={env.url} dense>
            {env.label}
          </MenuItem>
        ))}
      </Select>
      <IconButton
        size="small"
        disabled={!isLocalApi}
        onClick={() => setIsClosed(true)}
        sx={{
          color: "inherit",
          p: 0.5,
          opacity: isLocalApi ? 0.85 : 0.35,
          "&.Mui-disabled": { color: "inherit" },
          "&:hover": isLocalApi
            ? { opacity: 1, backgroundColor: "rgba(255,255,255,0.12)" }
            : undefined,
        }}
      >
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Stack>
  );
}
